import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';
import moment from 'moment'

const toast = useToast();
const useBookYourAppointmentStore = defineStore({
    id: 'bookYourAppointment',
    state: () => ({
        form: {
            salutationList: [
                'common.dr',
                'common.mr',
                'common.ms',
                'common.mrs',
                'common.mx',
                'common.master',
                'common.miss'
            ],
            timeslotList: [
            ],
            preferredLocationList: [
                {
                    group: 'common.newTerritories',
                    locationList: [
                        'common.islands',
                        'common.kwaiTsing',
                        'common.north',
                        'common.saiKung',
                        'common.shaTin',
                        'common.taiPo',
                        'common.tsuenWan',
                        'common.tuenMun',
                        'common.yuenLong'
                    ]
                },
                {
                    group: 'common.kowloon',
                    locationList: [
                        'common.kowloonCity',
                        'common.kwunTong',
                        'common.shamShuiPo',
                        'common.wongTaiSin',
                        'common.yauTsimMong'
                    ]
                },
                {
                    group: 'common.hongkongIsland',
                    locationList: [
                        'common.centralAWestern',
                        'common.eastern',
                        'common.southern',
                        'common.wanChai'
                    ]
                },

            ],
            serviceCategoryList: [
                'bookYourAppointment.generalPract',
                'bookYourAppointment.specialist',
                'bookYourAppointment.telemedicine',
                'bookYourAppointment.checkUp',
                'bookYourAppointment.nurseAdvisory',
            ]
        }
    }),
    getters: {},
    actions: {
        async bookAppointment(body: object) {
            try {
                console.log('api: book appointment: ' + JSON.stringify(body));
                const response: any = await apiClient.post('/api/scwebsite/bookAppointment/', body);
                const isSuccess = response.statusCode;
                //debugger;
                if (!isSuccess) {
                    console.log('response? ' + JSON.stringify(response));
                    var error = Object.prototype.toString.call(response.errorMessage) === '[object Object]' ? JSON.stringify(response.errorMessage) : response.errorMessage;
                    throw new Error(error)
                }
                toast.success('Send Email Success');
                return isSuccess;
            } catch (err: any) {
                toast.error(err.message);
            }
        },
        availableTimeslot(appointmentTimeslot: number, startTime: string, endTime: string, startLunchTime: string, endLunchTime: string, haveLunchTime: boolean) {
            var availableTimeList = [];
            var startTimeStr = moment(startTime, "HH:mm").format("HH:mm");
            var endTimeStr = moment(endTime, "HH:mm").format("HH:mm");
            var startLunchTimeStr = moment(startLunchTime, "HH:mm").format("HH:mm");
            var endLunchTimStr = moment(endLunchTime, "HH:mm").format("HH:mm");
            var currentTime = startTimeStr
            availableTimeList[0] = startTimeStr;

            while (currentTime != endTimeStr) {
                currentTime = moment(currentTime, "HH:mm").add(appointmentTimeslot, "minutes").format("HH:mm");
                let lunchTime = moment(currentTime, "HH:mm").isBetween(moment(startLunchTimeStr, "HH:mm"), moment(endLunchTimStr, "HH:mm"))
                    || currentTime == endTimeStr
                    || currentTime == startLunchTimeStr
                if (lunchTime && haveLunchTime) continue;
                availableTimeList.push(currentTime);
            }
            return availableTimeList;
        },
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useBookYourAppointmentStore, import.meta.hot));
}

export { useBookYourAppointmentStore };
